import React, { useEffect } from 'react'
import { withStyles, Radio } from '@material-ui/core';
import PropTypes from 'prop-types';
import getObjectValue from 'libs/getObjectValue';

const style = theme => ({
	root: {

	},
	hideElement: {
		width: 42,
	}
})

function RadioButton({
	classes,
	hide,
	formikProps,
	id,
	pairId,
	disabled = false
}) {
	
	const value = getObjectValue(id, formikProps.values, false)
	const pairValue = getObjectValue(pairId, formikProps.values, false)

	useEffect(() => {
		if(pairId !== undefined){
			formikProps.setFieldValue(id, !pairValue)
		}
	// eslint-disable-next-line
	}, [pairValue])

	const handleClick = (e) => {
		const value = e.target.checked;
		formikProps.setFieldValue(id, value)
		if(pairId !== undefined){
			formikProps.setFieldValue(pairId, !value)
		}
	}

	if (hide) {
		return <div className={classes.hideElement} />
	}

	return (
		<Radio
			type='checkbox'
			onClick={handleClick}
			checked={value}
			disabled={disabled}
		/>
	)
}

RadioButton.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(RadioButton);